import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios)
axios.defaults.baseURL = process.env.BASE_URL
// axios.defaults.baseURL = 'http://127.0.0.1:8089/'
axios.defaults.headers['X-Requested-With'] = 'XMLHttpRequest'
axios.defaults.withCredentials = true;

axios.interceptors.request.use((request) => {
  // .....
  // 微前端模式下，增加上下文路径
  if (window.__POWERED_BY_QIANKUN__) {
    // 访问环境地址绝对路径
    request.url = Vue.prototype.$urlPathSuffix + request.url;
    // 请求头带上TOKEN信息
    request.headers['GIS-TOKEN'] = Vue.prototype.$mainFramworkSession;
    // 请求头带上环境信息
    request.headers['GIS-ENV'] = Vue.prototype.$systemEnv;
    // 请求头带上空间ID信息
    request.headers['GIS-SPACE-ID'] = Vue.prototype.$spaceId;
    // 请求头带上应用ID信息
    request.headers['GIS-APP-ID'] = Vue.prototype.$appId;
  }
  // .....
  return request;
});
axios.interceptors.response.use((response) => {
  const { data = {}, status, statusText } = response
  let message

  if (data.code) {
    // Create an unified error code in constant case.
    // For example: unknown-error => UNKNOWN_ERROR
    data.CODE = data.code
      .replace(/([a-z])([A-Z])/g, '$1_$2')
      .replace(/\W+/g, '_')
      .toUpperCase()
  }

  if (status >= 200 && status < 300) {
    if (data.code !== 'success') {
      ({ message } = data)
    }
  } else {
    message = data.message || statusText
  }

  if (message) {
    const error = new Error(message)

    error.code = data.code
    error.CODE = data.CODE
    error.data = data.data
    error.response = response
    throw error
  }

  return data
})

export default axios
